import { useUserContext } from "@/components/user-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";

import { LoggedOutDefault } from "../default";

import { LoggedOutJiraServiceManagementFree } from "./logged-out-jira-service-management-free";
import { LoggedOutJiraServiceManagementPremium } from "./logged-out-jira-service-management-premium";
import { LoggedOutJiraServiceManagementStandard } from "./logged-out-jira-service-management-standard";

export const LoggedOutJiraServiceManagement = () => {
    const { edition } = useUserContext();

    if (edition === "free") {
        return <LoggedOutJiraServiceManagementFree />;
    }

    if (checkFeatureFlagGate(featureFlags.jfindJsmPaidEditionsMigration)) {
        if (edition === "standard") {
            return <LoggedOutJiraServiceManagementStandard />;
        }
        if (edition === "premium") {
            return <LoggedOutJiraServiceManagementPremium />;
        }
    }

    // bxpkit catch-all (paid editions if gate is off)
    return <LoggedOutDefault />;
};
